import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import Ceo from '../../assets/images/ceo.jpg';
import SERV from '../../assets/images/service2.jpg';
import { motion } from 'framer-motion'; // Importation de Framer Motion

const ServicePageBienEtre = () => {
  return (
    <section id="main-container" className="main-container" style={{ backgroundImage: 'url(images/assets/ban4.jpg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="sidebar sidebar-left">
              <div className="widget">
                <h3 className="widget-title">Solutions</h3>
                <ul className="nav service-menu">
                  <li ><Link to="/Securite-residentielle-industrielle">Sécurité résidentielle et industrielle</Link></li>
                  <li className="active"><Link to="/Protection-rapprochee">Protection rapprochée</Link></li>
                  <li><Link to="/Surveillance-de-sites-minierse">Surveillance de sites miniers</Link></li>
                  <li><Link to="/Transport-securise">Transport sécurisé</Link></li>
                 
                </ul>
              </div>

              <div className="widget">
                <div className="quote-item quote-border">
                  <div className="quote-text-border">
                   L’excellence au service de votre protection. 
                  </div>
                  <div className="quote-item-footer">
                    <img className="testimonial-thumb" src={Ceo} alt="testimonial" />
                    <div className="quote-item-info">
                      <h3 className="quote-author text-dark">Kanku Kalala Pierre</h3>
                      <span className="quote-subtext">Administrateur Général <br /> et Associé Unique</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="content-inner-page">
              {/* Titre avec animation */}
              <motion.h2
                className="column-title mrt-0 fw-bold"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
             Protection rapprochée
              </motion.h2>

              <div className="row">
                 <div className="col-md-12">
                  <div className="card mb-4" >
  <img src={SERV} className="card-img-top img-fluid hover-shadow" alt="Sunset Over the Sea"/>
 
</div>
                 </div>
                <div className="col-md-12">
                  {/* Paragraphe animé */}
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5, duration: 1 }}
                  >
                  Chez GEKAS Security and Consulting SARL, le service de protection rapprochée est dédié à la sécurité des personnes à haut profil, qu’il s’agisse de dirigeants d’entreprise, de personnalités politiques, diplomatiques ou autres figures publiques. Nous mettons à disposition des agents hautement qualifiés, formés aux techniques de défense, d’évacuation d’urgence, d’analyse de risque et à la gestion de situations sensibles, pour garantir une sécurité sans faille dans tous les déplacements ou événements.
                  </motion.p>
                  <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
                 Notre équipe élabore des plans de protection personnalisés, fondés sur une évaluation approfondie des risques et du contexte dans lequel évolue la personne protégée. Nous assurons une présence discrète mais dissuasive, en combinant la vigilance humaine à l’utilisation d’outils technologiques (géolocalisation, communication sécurisée, véhicules blindés si nécessaire), afin de prévenir toute tentative d’agression, d’enlèvement ou d’atteinte à l’intégrité physique.
                  </motion.p>

                   <motion.p
                    className="text-left"
                    style={{ fontFamily: 'Times', fontSize: '20px' }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                  >
                Plus qu’un simple service, la protection rapprochée de GEKAS est une véritable alliance de confiance. Nous opérons dans le strict respect de la confidentialité, de la loi et de l’éthique professionnelle. Notre objectif est clair : permettre à chaque client de poursuivre ses activités et déplacements en toute sérénité, avec la certitude que sa sécurité est assurée par des experts engagés et rigoureux.


                  </motion.p>
                </div>
              </div>

              <div className="gap-40"></div>

       

              <div className="gap-40"></div>

         

              <div className="gap-40"></div>

              {/* Call to Action avec animation sur le bouton */}
              <div className="call-to-action classic">
                <div className="row align-items-center">
                  <div className="col-md-8 text-center text-md-left">
                    <div className="call-to-action-text">
                      <h4 className="action-title">Êtes-vous intéressé par ce service ?</h4>
                    </div>
                  </div>
                  <div className="col-md-4 text-center text-md-right mt-3 mt-md-0">
                    <motion.div
                      className="call-to-action-btn"
                      whileHover={{ scale: 1.1, color: '#ffffff', backgroundColor: '#ff9800' }}
                    >
                      <Link to="/Contact" className="btn btn-warning">
                        Contactez-nous
                      </Link>
                    </motion.div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServicePageBienEtre;
